import React from "react";
import classnames from "classnames";
import isEqual from "lodash/isEqual";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
//icons
import ActionPrint from "@material-ui/icons/Print";
// jazasoft
import { PageHeader, PageFooter, BackButton, showNotification } from "jazasoft";
// local
import OrderDetails from "../../OrderDetails";
import MicroController from "./MicroController";
//helpers
import SettingKeys from "../../../utils/SettingKeys";
import fetchSetting from "../../../utils/fetchSetting";
import { printPartRecuttingReport, getData, DataType } from "../../feedback/feedbackHelper";
import { DEFAULT_SEPARATOR, MicroReportId } from "../../../constants";
import { OState } from "../../../utils/types";

const styles = theme => ({
  root: {},
  container: {
    margin: "1.5em",
    padding: 0
  },
  marginVertical: {
    margin: "1.5em 0"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    margin: "1.5em"
  }
});

class PartsRecuttingReportView extends React.Component {
  state = {
    busy: false,
    defectTypes: undefined
  };

  componentDidMount() {
    fetchSetting(SettingKeys.DEFECT_TYPES, this.props.dispatch, setting =>
      this.setState({ defectTypes: JSON.parse(setting.value) })
    );
    this.props.fetchParts();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.order, nextProps.order)) {
      const order = nextProps.order;
      const fabricIds =
        order && order.flowInfoList.flatMap(part => part.ledgerList || []).map(ledger => ledger.fabricId);
      this.props.updateFabricsDeep(fabricIds);
    }
  }

  onPrint = orderFlow => () => {
    this.setState({ busy: true });
    const { order, parts, fabrics } = this.props;
    if (orderFlow.stateValue > OState.MAIN_CUTPLAN_COMPLETED.stateValue) {
      this.props.fetchLaySlip(orderFlow, (layslip, err) => {
        if (layslip) {
          const rows = getData({
            dataType: DataType.PART_RECUT_ROLL,
            order,
            orderFlow,
            fabrics,
            layMap: layslip,
            styleColor: orderFlow.styleColor
          });
          printPartRecuttingReport({
            order,
            orderFlow,
            parts,
            defectTypes: this.state.defectTypes,
            styleColor: orderFlow.styleColor,
            rows
          });
        } else {
          console.log(err);
        }
        this.setState({ busy: false });
      });
    } else {
      this.props.dispatch(showNotification("Planning not done yet."));
    }
  };

  render() {
    const { classes, order, basePath, i18nKey, resource, orderFlowMap } = this.props;

    const orderFlowList = orderFlowMap ? Object.keys(orderFlowMap).map(key => orderFlowMap[key]) : [];

    return (
      <div className={classnames(classes.root)}>
        <PageHeader title="Parts Recutting Report" />

        {order && Object.keys(order).length > 0 && (
          <div id="container" className={classes.container}>
            {/*Order Details */}
            <OrderDetails
              id="order-details"
              className={classes.border}
              record={order}
              basePath={basePath}
              resource={resource}
              i18nKey={i18nKey}
            />
            {orderFlowList.length > 0 && (
              <Paper className={classes.marginVertical} square>
                <List>
                  {orderFlowList
                    .flatMap(of =>
                      of.styleColorList
                        .sort((a, b) => (a < b ? -1 : 1))
                        .map(styleColor => ({
                          ...of,
                          styleColor,
                          style: styleColor?.split(DEFAULT_SEPARATOR)[0],
                          color: styleColor?.split(DEFAULT_SEPARATOR)[1]
                        }))
                    )
                    .map((of, idx) => (
                      <ListItem key={idx}>
                        <ListItemText>{`${of.product?.name}, ${of.style}, ${of.color}, ${of.part}, Lot${of.lot}`}</ListItemText>
                        <ListItemSecondaryAction>
                          <Button
                            edge="end"
                            aria-label="Print"
                            color="primary"
                            onClick={!this.state.busy ? this.onPrint(of) : null}>
                            <ActionPrint style={{ marginRight: 4 }} />
                            Print
                          </Button>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                </List>
              </Paper>
            )}

            {orderFlowList.length === 0 && (
              <div className={classes.displayCenter}>
                <Typography color="secondary" variant="h6">
                  Report not available
                </Typography>
              </div>
            )}

            <PageFooter>
              <BackButton variant="contained" color="default" />
            </PageFooter>
          </div>
        )}
      </div>
    );
  }
}

const StyledPartsRecuttingReport = withStyles(styles)(PartsRecuttingReportView);

const PartsRecuttingReport = props => (
  <MicroController microReportId={MicroReportId.PART_RECUTTING} {...props}>
    {controllerProps => <StyledPartsRecuttingReport {...props} {...controllerProps} />}
  </MicroController>
);

export default PartsRecuttingReport;
